import { render, staticRenderFns } from "./SuburbTrendsWithNotes.vue?vue&type=template&id=3b80d030&scoped=true"
import script from "./SuburbTrendsWithNotes.vue?vue&type=script&lang=js"
export * from "./SuburbTrendsWithNotes.vue?vue&type=script&lang=js"
import style0 from "./SuburbTrendsWithNotes.vue?vue&type=style&index=0&id=3b80d030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b80d030",
  null
  
)

export default component.exports